import script from "./invitePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./invitePage.vue?vue&type=script&setup=true&lang=ts"

import "./invitePage.vue?vue&type=style&index=0&id=0a304e13&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a304e13"]])

export default __exports__